/*
 * Copyright (c) Nexign, JSC, 2020-2025.
 */
/**
 * The init translation constant for widget Search Accounts
 *
 * @author Anton Panasenko
 * @author Nikolay Sviridov
 * @version 1.36.0
 * @since 1.3.0
 */

import IWidgetSearchAccountsTranslation from '../../../types/pages/dashboard/widgetSearchAccounts';

const initTranslationWidgetAccountSelect: IWidgetSearchAccountsTranslation = {
    balance: '',
    failedButton: '',
    failedText: '',
    label: '',
    notFound: '',
    number: '',
    placeholder: '',
    region: '',
    subsCount: '',
    name: '',
    inn: '',
};

export default initTranslationWidgetAccountSelect;
